import { Theme } from '@mui/material';
/**
 * Styling for ccf-notification-settings
 * @returns ccf-notification-settings CSS properties as a JSON object
 * @example CcfNotificationSettingsStyles(theme)
 */
const CcfAVNotificationsStyles = (theme: Theme, isSmView: boolean) => {
  const styles = {
    header: {
      display: 'flex',
      lineHeight: '2.5px',
      color: theme.palette.primary.dark,
    },
    headerText: {
      margin: 0,
      whiteSpace: 'pre-wrap',
      wordBreak: 'normal',
      overflowWrap: 'anywhere',
      fontSize: '18px',
      color: theme.palette.primary.dark,
      fontWeight: 700,
    },
    settingsGrid: {
      maxWidth: 'fit-content',
    },
    subHeader: {
      fontSize: '0.875rem',
      color: theme.palette.primary.dark,
      display: 'flex',
      marginBottom: '-12px',
    },
    icon: {
      padding: '0px 0px 0px 18px',
    },
    speakerIcon: {
      padding: '0 5px',
      cursor: 'pointer',
      fontSize: '10px',
    },
    toggle: {
      display: 'flex',
      flexWrap: 'wrap',
      minWidth: '387px',
      [theme.breakpoints.down('xl')]: {
        minWidth: '300px',
      },
    },
    voicetoggle: {
      minWidth: '300px',
      [theme.breakpoints.down('xl')]: {
        minWidth: '200px',
      },
    },
    select: {
      color: theme.palette.text.dark,
      width: '107px',
      height: '30px',
      li: {
        minHeight: '20px',
      },
    },
    tone: {
      padding: '0px 10px 0px 0px',
      display: 'flex',
      alignItems: 'center',
    },
    listStyle: {
      paddingLeft: '0px',
      paddingRight: '10px',
      width: 'fit-content',
    },
    labelStyle: {
      marginLeft: '0px',
      color: theme.palette.text.secondary,
    },
    selectMenu: {
      maxHeight: 150,
    },
  };
  return styles;
};

export default CcfAVNotificationsStyles;
